export default "__VITE_ASSET__DnVNxj5E__"